<template>
  <a-card>
    <div class="main-panel" style="height: 800px">
      <div class="main-content-wrap">
        <div class="main-operation-wrap">
          <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }" :colon="false">
            <a-row :gutter="20">
              <a-col :span="6">
                <a-form-model-item label="时间周期">
                  <a-select v-model="form.time" placeholder="请选择" clearable>
                    <a-select-option
                      v-for="item in timeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="2">
                <a-form-model-item label=" " :colon="false">
                  <a-button type="primary" icon="el-icon-search" @click="getData">搜索</a-button>
                </a-form-model-item>
              </a-col>
              <a-col :span="2">
                <a-form-model-item label=" " :colon="false" v-if="isAdmin">
                  <a-upload
                    type="primary"
                    action="/api/business-incentives/import-business-incentives"
                    @change="handleSuccess"
                    :before-upload="beforeAvatarUpload"
                    :showUploadList=false>
                    <a-button type="primary">上传文件</a-button>
                  </a-upload>
                </a-form-model-item>
              </a-col>
              <a-col span="2">
                <a-form-model-item label=" ">
                  <a-button type="primary" icon="el-icon-download" @click="exportExcel">导出EXCEL
                  </a-button>
                </a-form-model-item>
              </a-col>
              <a-col span="2">
                <a-form-model-item label=" ">
                  <a-button type="primary" icon="el-icon-download" @click="downloadZip">下载文件
                  </a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <a-row>
          <a-col :span="24">
            <div>
              <simple-chart :option="businessIncentives.option"
                            style="width: 100%;height: 600px;margin-top: 20px;background-color: white"></simple-chart>
            </div>
          </a-col>
        </a-row>
      </div>

    </div>
  </a-card>

</template>

<script>
import SimpleChart from "../components/SimpleChart";
import {getBusinessIncentives, getBusinessIncentivesExcel} from "../api/businessIncentivesApi";
import {getTime} from "../utils/dateUtil";

async function getData() {
  let _this = this;
  const result = await getBusinessIncentives({
    days: _this.form.time
  });
  // console.log(result)
  this.data = result.data;
  this.businessIncentives.option.xAxis[0].data = result.data.xList;
  this.businessIncentives.option.series[0].data = result.data.sumList;
  this.businessIncentives.option.series[1].data = result.data.avgList;
  this.businessIncentives.option.series[2].data = result.data.countList;
  this.timeLabel = result.data.day;

}

function handleSuccess(res) {
  let that = this;
  // setTimeout(() => {
  if (this.uploadTrue) {
    if (res.file.response && res.file.response.code === 1200) {
      that.$message.success('上传成功');
      this.getList();
    }
  } else {
    this.uploadTrue = !this.uploadTrue
  }
  // }, 1000)
}

function beforeAvatarUpload(file) {
//        判断上传文件的后缀 是否为 xls 或 xlsx 格式
  const index = file.name.lastIndexOf('.');
  const fileName = file.name.substring(index + 1);
  if (fileName !== 'xls' && fileName !== 'xlsx') {
    let that = this;
    this.$confirm({
      title: '上传文件必须为 .xls 或 .xlsx 格式 ?',
      content: '',
      okType: 'warning',
      onOk() {
        that.form.dialogVisibleWorker = false;
      },
      //   this.onCancel()
      onCancel() {
        that.form.dialogVisibleWorker = false;
      },
      class:
        'test',
    });
    // this.$confirm('上传文件必须为 .xls 或 .xlsx 格式 ', '提示', {
    //   confirmButtonText: '确定',
    //   cancelButtonText: '取消',
    //   type: 'warning',
    // }).catch(() => {
    //   //                关闭批量上传弹窗
    //   this.form.dialogVisibleWorker = false;
    // });
    return false;
  }
}

function exportExcel() {
  let _this = this;
  // const result = await getBusinessIncentives({
  //   days: _this.form.time
  // });
  // if (result.code === 1200) {
  let list = [];
  const length = _this.data.xList.length;
  for (let i = 0; i < length; i++) {
    list.push({
      people: _this.data.xList[i],
      sum: _this.data.sumList[i],
      avg: _this.data.avgList[i],
      count: _this.data.countList[i],
    })
  }
  require.ensure([], () => {
    const { export_json_to_excel } = require('../utils/Export2Excel');
    const tHeader = ['姓名', '平均数', '总数', '计次'];
    // 上面设置Excel的表格第一行的标题
    const filterVal = ['people', 'avg', 'sum', 'count'];
    // 上面的index、nickName、name是tableData里对象的属性
    const data = this.formatJson(filterVal, list);
    let day = '';
    for (const timeOption of _this.timeOptions) {
      if (timeOption.value === _this.timeLabel) {
        day = timeOption.label
      }
    }
    export_json_to_excel(tHeader, data, `导出` + day + `-${ getTime() }`);
  });
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]));
}

async function downloadZip() {
  this.$confirm({
    title: '是否下载商务激励.7z?',
    content: '',
    onOk() {
      window.location.href = '/api/signForImg/商务激励.7z';
    },
    onCancel() {
    },
    class:
      'test',
  });
  // this.$confirm('是否下载客户与商务人员关系表.xlsx？', '提示', {
  //   type: 'warning',
  //   confirmButtonText: '确认',
  //   cancelButtonText: '取消',
  // }).then(async () => {
  //   window.location.href = '/api/signForImg/客户与商务人员关系表.xlsx';
  // });
}

export default {
  name: "BusinessIncentives",
  components: { SimpleChart },
  data() {
    return {
      data: [],
      uploadTrue: true,
      businessIncentives: {
        option: {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            right: '20%'
          },
          legend: {
            data: ['总数', '平均数', '计次']
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {
                alignWithLabel: true
              },
              data: []
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '计次',
              position: 'right',
              axisLine: {
                lineStyle: {
                  color: '#5793f3'
                }
              },
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} 次'
              }
            },
            {
              type: 'value',
              name: '总数',
              position: 'right',
              offset: 80,
              axisLine: {
                lineStyle: {
                  color: '#d14a61'
                }
              },
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} h'
              }
            },
            {
              type: 'value',
              name: '平均数',
              position: 'left',
              axisLine: {
                lineStyle: {
                  color: '#675bba'
                }
              },
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} h'
              }
            }
          ],
          series: [
            {
              name: '总数',
              type: 'bar',
              yAxisIndex: 1,
              data: []
            },
            {
              name: '平均数',
              type: 'bar',
              yAxisIndex: 2,
              data: []
            },
            {
              name: '计次',
              type: 'bar',
              yAxisIndex: 0,
              data: []
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 100
            },
            {
              type: 'inside',
              start: 0,
              end: 100
            }
          ]
        }
      },
      form: {
        time: 'months'
      },
      timeLabel: 'months',
      timeOptions: [{
        label: '上月',
        value: 'months'
      }, {
        label: '本月',
        value: 'month'
      }, {
        label: '本季度',
        value: 'quarter'
      }, {
        label: '本年',
        value: 'year'
      }, {
        label: '近30天',
        value: '30'
      }, {
        label: '近60天',
        value: '60'
      }, {
        label: '近90天',
        value: '90'
      }],
      isAdmin: false
    }
  },
  methods: {
    getData,
    handleSuccess,
    beforeAvatarUpload,
    exportExcel,
    formatJson,
    downloadZip
  },
  created() {
    const role = JSON.parse(localStorage.getItem("roles"))
    if (role[0].code === 'admin') {
      this.isAdmin = true
    }
    this.getData();
  }
}
</script>

<style scoped>

</style>
